export class DeleteCloudAccountResponse {
    accountId?: string;
}